import React, { useState } from 'react';
import { FieldError, useFormContext } from 'react-hook-form';
import get from 'lodash/get';
import { InputMask } from '../../../../CommonComponents/OPL/Input/InputMask';
import { EditableField } from '../../components/EditableField/EditableField';
import { DraftAccountDTO } from '../../AccountOpening.meta';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { SpaceProps } from '../../../../theme/styledProps';

interface Props extends SpaceProps {
  isReview?: boolean;
  fieldName: string;
  draftAccount: DraftAccountDTO;
}

export const Phone: React.FC<Props> = ({ fieldName, isReview, draftAccount, ...rest }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const [isEditing, setIsEditing] = useState(!isReview);

  if (!isEditing) {
    return (
      <EditableField onEdit={() => setIsEditing(true)}>
        {get(draftAccount, fieldName)}
      </EditableField>
    );
  }

  return (
    <Box {...rest}>
      <InputMask
        {...register(fieldName)}
        label={isReview ? undefined : 'Phone Number'}
        type="tel"
        mask="(999) 999-9999"
        placeholder="(555) 867-5309"
        leftIcon="far fa-phone"
        formVariant={get(errors, fieldName) ? 'error' : undefined}
        helperText={(get(errors, fieldName) as FieldError | undefined)?.message}
        aria-label="Phone Number"
        autoComplete="tel"
      />
    </Box>
  );
};
